/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ progress: NonNullable<unknown> }} Toast_Upload_ProgressInputs */

const en_toast_upload_progress = /** @type {(inputs: Toast_Upload_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.progress}% uploaded`)
};

const es_toast_upload_progress = /** @type {(inputs: Toast_Upload_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.progress}% subido`)
};

/**
* | output |
* | --- |
* | "{progress}% uploaded" |
*
* @param {Toast_Upload_ProgressInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const toast_upload_progress = /** @type {((inputs: Toast_Upload_ProgressInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Upload_ProgressInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_toast_upload_progress(inputs)
	return en_toast_upload_progress(inputs)
});